import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Grid, TextField, Button, Autocomplete } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const InventoryFilters = ({
  searchTerm,
  minQuantity,
  maxQuantity,
  addedByFilter,
  filterOptions,
  onSearchChange,
  onFilterChange,
  onClearFilters,
}) => {
  // Create added by options from filter options
  const addedByOptions = filterOptions?.added_by_options || [];
  const formattedAddedByOptions = [{ id: 'All', full_name: 'All Contributors' }, ...addedByOptions];

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={2.5}>
            <TextField
              fullWidth
              placeholder="Search items..."
              value={searchTerm}
              onChange={onSearchChange}
              size="small"
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              label="Min Quantity"
              type="number"
              value={minQuantity}
              onChange={(e) => onFilterChange('minQuantity', e.target.value)}
              size="small"
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              label="Max Quantity"
              type="number"
              value={maxQuantity}
              onChange={(e) => onFilterChange('maxQuantity', e.target.value)}
              size="small"
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              size="small"
              value={
                formattedAddedByOptions.find((emp) => emp.id === addedByFilter) || {
                  id: 'All',
                  full_name: 'All Contributors',
                }
              }
              onChange={(event, newValue) => {
                onFilterChange('addedBy', newValue?.id || 'All');
              }}
              options={formattedAddedByOptions}
              getOptionLabel={(option) => option?.full_name || ''}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => <TextField {...params} label="Added By" />}
              clearOnEscape
            />
          </Grid>
          <Grid item xs={12} sm={6} md={1}>
            <Button variant="outlined" onClick={onClearFilters} size="small" sx={{ height: '40px' }}>
              Clear Filters
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

InventoryFilters.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  nameFilter: PropTypes.string.isRequired,
  minQuantity: PropTypes.string.isRequired,
  maxQuantity: PropTypes.string.isRequired,
  addedByFilter: PropTypes.string.isRequired,
  filterOptions: PropTypes.object.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

export default InventoryFilters;
